import { FC } from 'react';
import { createStyles, makeStyles, useTheme } from '@material-ui/core';
import { WbInfoTooltip, Severity } from '@agilelab/plugin-wb-platform';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

const useStyles = makeStyles(() =>
  createStyles({
    iconContainer: {
      position: 'absolute',
      right: -20,
      top: -16,
      borderRadius: '100%',
      background: 'white',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      border: '2px solid white',
      zIndex: 1,
    },
  }),
);

interface Props {
  hide?: boolean;
  label: string;
}

export const Error: FC<Props> = ({ hide, label }) => {
  const classes = useStyles();
  const theme = useTheme();
  return (
    <WbInfoTooltip
      title={label}
      severity={Severity.Error}
      iconWrapperClassName={classes.iconContainer}
      icon={
        <>
          {hide && (
            <ErrorOutlineIcon
              style={{
                color: 'white',
                fontSize: 50,
                opacity: 0.8,
                position: 'absolute',
                zIndex: 2,
              }}
            />
          )}

          <ErrorOutlineIcon
            style={{ color: theme.palette.relationsGraph.error, fontSize: 30 }}
          />
        </>
      }
    />
  );
};
